import {PermissionType} from '@core/api/data-access';
import {GlobalDialogConfig} from '@shared/dialog';

/**
 * Type definition for the global application route configuration.
 * This configuration is a partial record with the following properties:
 * - dialog: Configuration for the global dialog. The data type for the dialog can be any.
 * - permissions: An array of permission types.
 * - autoHideSidenav: A boolean indicating whether the side navigation should be automatically hidden.
 */
export type GlobalAppRouteConfig<DialogDataType = any> = Partial<{
	dialog: GlobalDialogConfig<DialogDataType>;
	permissions: PermissionType[];
	autoHideSidenav: boolean;
}>;

/**
 * Type definition for the global application route.
 * This type extends the global application route configuration.
 */
export type GlobalAppRoute<C extends GlobalAppRouteConfig = GlobalAppRouteConfig> = AppRoute<C>;

/**
 * Factory function for creating a global application route.
 * This function takes a configuration object and returns an application route with the provided configuration.
 *
 * @param config - The configuration for the global application route.
 * @returns A global application route with the provided configuration.
 */
export const globalAppRouteConfigFactory = <C extends GlobalAppRouteConfig>(config: C): GlobalAppRoute<C> => config;
